<template>
  <CHeader with-subheader style="background-color: #4786ff !important;">
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="30" viewBox="0 0 81 24" svg-inline="" role="presentation" focusable="false" tabindex="-1"><defs><path id="a" d="M0 .239h16.41v18.894H0z"></path></defs><g fill="none" fill-rule="evenodd"><path fill="#FFF" d="M28.037 7.505a.916.916 0 00-.916-.915c-1.842 0-3.796.182-5.809.542a.915.915 0 00-.754.901v9.868c0 .505.41.915.916.915h1.494c.505 0 .916-.41.916-.915v-7.878a33.95 33.95 0 013.237-.13c.505 0 .916-.41.916-.915V7.505zm8.739 2.382v5.96c-1.17.171-1.817.171-2.6.171-1.863 0-2.93-1.188-2.93-3.26 0-1.427.52-3.128 2.996-3.128.7 0 1.534.034 2.534.257m2.432-8.506h-1.494a.915.915 0 00-.915.916v4.43a14.825 14.825 0 00-2.69-.225c-3.746 0-6.168 2.455-6.168 6.256 0 3.794 2.4 6.344 5.971 6.344h.368c1.51 0 2.606-.033 5.097-.499a.916.916 0 00.747-.9V2.297a.915.915 0 00-.916-.916m10.737 9.912h-5.042c.403-1.099 1.33-1.729 2.613-1.729 1.27 0 2.12.619 2.429 1.729m-2.45-4.791c-3.646 0-6.19 2.59-6.19 6.3 0 3.794 2.575 6.344 6.409 6.344 1.638 0 2.858-.32 4.28-.74a.917.917 0 00.64-1.056l-.242-1.23a.919.919 0 00-1.123-.711c-1.419.36-2.351.542-3.51.542-1.342 0-2.307-.585-2.763-1.64h7.29a.916.916 0 00.907-.793c.074-.544.074-.762.074-1.294-.026-3.423-2.346-5.722-5.773-5.722m13.538.088c-1.842 0-3.797.182-5.809.542a.916.916 0 00-.755.901V17.9c0 .506.41.916.916.916h1.495c.505 0 .916-.41.916-.916v-7.877a33.953 33.953 0 013.237-.13c.506 0 .916-.41.916-.915V7.505a.916.916 0 00-.916-.915m4.506-5.209h-1.495a.916.916 0 00-.916.916V17.9c0 .505.41.915.916.915h1.495c.505 0 .915-.41.915-.915V2.297a.916.916 0 00-.915-.916M80.735 7.27a.915.915 0 00-.781-.439h-1.692a.915.915 0 00-.815.499l-3.316 6.47-3.502-6.489a.916.916 0 00-.806-.48H68.11a.916.916 0 00-.804 1.352l5 9.203-2.572 5.042a.917.917 0 00.816 1.332h1.691c.345 0 .66-.193.816-.5L80.77 8.165a.916.916 0 00-.035-.895M18.094 4.992a7.217 7.217 0 00-5.654-3.03l-.092-.003a3.093 3.093 0 00-.137-.004c-3.531 0-6.488 2.577-7.038 6.129.596-2.056 2.301-3.312 4.68-3.312 2.998 0 4.936 1.972 4.936 5.025 0 3.066-1.938 5.047-4.936 5.047-2.449 0-4.184-1.335-4.73-3.506.166 1.208.576 2.557 1.497 3.682 1.644 2.01 4.512 2.833 8.474 2.425l.565-.07c2.254-1.641 3.609-4.319 3.609-7.578 0-1.807-.419-3.433-1.174-4.805"></path><path fill="#FFF" d="M16.363 3.268c.695.491 1.3 1.1 1.774 1.796-.012-.023-.028-.045-.04-.069a7.104 7.104 0 00-1.734-1.727"></path><g transform="translate(0 .008)"><mask id="b" fill="#fff"><use xlink:href="#a"></use></mask><path fill="#FFF" d="M15.282 1.934a9.199 9.199 0 00-.454-.287c-.065-.04-.13-.08-.197-.118-.09-.05-.184-.099-.276-.147a9.936 9.936 0 00-.484-.237l-.118-.054a9.053 9.053 0 00-.384-.16l-.012-.004A10.155 10.155 0 0012.04.518L12 .51a10.363 10.363 0 00-1.866-.258L10.08.249A10.985 10.985 0 009.634.24c-2.969 0-5.706 1.25-7.509 3.431A9.395 9.395 0 000 9.646v.068c0 5.282 4.161 9.419 9.472 9.419h.124c.977-.012 1.803-.097 2.532-.244.079-.016.159-.032.235-.05.034-.007.067-.016.1-.024a9.74 9.74 0 00.283-.071l.064-.019a8.525 8.525 0 00.335-.1 9.113 9.113 0 001.773-.797c-4.014.373-6.891-.504-8.589-2.582-2.37-2.899-1.562-7.051-1.526-7.226l.006-.033c.59-3.72 3.696-6.415 7.402-6.415.052 0 .103.003.154.005l.086.004a7.637 7.637 0 013.959 1.26 9.255 9.255 0 00-1.128-.907" mask="url(#b)"></path></g></g></svg>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-12">
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav>
      <TheHeaderDropdownAccnt/>
      <TheHeaderDropdownPartners ref="partnersDropdown" @show="showAccountModal"/>
      <NewAccountModal ref="newAccountModal" @store="storeAccount"></NewAccountModal>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import router from '../router/index'
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownPartners from './TheHeaderDropdownPartners'
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif'
import TheHeaderDropdownTasks from './TheHeaderDropdownTasks'
import TheHeaderDropdownMssgs from './TheHeaderDropdownMssgs'
import NewAccountModal from '../components/configuration/NewAccountModal.vue'
import account_ws from '../services/account';
import login from '../services/login';

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownPartners,
    TheHeaderDropdownNotif, 
    TheHeaderDropdownTasks,
    TheHeaderDropdownMssgs,
    NewAccountModal
  },
  data () {
    return { 
      has_partners: 0,
      has_owners: 0
    }
  },
  mounted: async function() {
    let response = await account_ws.hasPartners(); 

    if(response.type == "success"){
      this.has_partners = response.data;
    }

    let response2 = await account_ws.hasOwnerAccounts(); 

    if(response2.type == "success"){
      this.has_owners = response2.data;
    }
  },
  methods: {
    showAccountModal () {
      this.$refs.newAccountModal.storeModal();
    },
    storeAccount (data) {
      this.$refs.partnersDropdown.refresh();
    },
    logout: function(){
      localStorage.removeItem("account");
      localStorage.removeItem("fiscal");
      localStorage.removeItem("token");

      router.push("login");
    },
  }
}
</script>
